import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  plus310ted5e4i90h as plus,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  OnField2kq8b4gk936v8 as OnField,
  IfIsType2zdboewhql4da as IfIsType,
  ListAllElements2qkljsceytb8 as ListAllElements,
  Always_getInstance177eud73uc475 as Always_getInstance,
  IfNotNullvieyp8szlv3m as IfNotNull,
} from './Condition.mjs';
import {
  OnFielduegjwkreacmm as OnField_0,
  IfIsType2q85mbl9d19gv as IfIsType_0,
  ListPerElement3otxrneyl53yk as ListPerElement,
  IfNotNull38wuwth0boumg as IfNotNull_0,
} from './Modification.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g as _SealedTypeDiscriminator___init__impl__jf77jn,
  matches17hm1adjr5zld as matches,
  variantShortNamey38i8usgp8vx as variantShortName,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u as _SealedTypeDiscriminator___get_serialName__impl__x46m55,
  SealedTypeDiscriminator__hashCode_impl_3l9vn82rzp7wjugbfem as SealedTypeDiscriminator__hashCode_impl_3l9vn8,
} from './SealedTypeDiscriminator.mjs';
import {
  listElement3jy3tr2z6og1q as listElement,
  nullElement39ujy5fzowmto as nullElement,
} from './SerializationHelpers.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_hd7dek_k$(typeSerial0) {
        return new (DataClassPathSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_hd7dek_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DataClassPathPartialClass;
function DataClassPathPartial() {
  if (DataClassPathPartialClass === VOID) {
    class $ {}
    initMetadataForClass($, 'DataClassPathPartial', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    DataClassPathPartialClass = $;
  }
  return DataClassPathPartialClass;
}
var DataClassPathAccessClass;
function DataClassPathAccess() {
  if (DataClassPathAccessClass === VOID) {
    class $ extends DataClassPath() {
      constructor(first, second) {
        super();
        this.first_1 = first;
        this.second_1 = second;
      }
      get_wei43m_k$(key) {
        var tmp0_safe_receiver = this.first_1.get_wei43m_k$(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0;
          try {
            tmp_0 = this.second_1.get_g4cbzo_k$(tmp0_safe_receiver);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Exception()) {
              var e = $p;
              printStackTrace(e);
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_afpr0i_k$('Could not get ' + this.second_1.get_name_woqyms_k$() + ' on ' + toString(tmp0_safe_receiver), e);
            } else {
              throw $p;
            }
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      set_iuhvb1_k$(key, value) {
        var tmp0_safe_receiver = this.first_1.get_wei43m_k$(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.first_1.set_iuhvb1_k$(key, this.second_1.setCopy_8a6bik_k$(tmp0_safe_receiver, value));
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
      }
      toString() {
        var tmp;
        var tmp_0 = this.first_1;
        if (tmp_0 instanceof DataClassPathSelf()) {
          tmp = this.second_1.get_name_woqyms_k$();
        } else {
          tmp = this.first_1.toString() + '.' + this.second_1.get_name_woqyms_k$();
        }
        return tmp;
      }
      get_properties_zhllqc_k$() {
        return plus(this.first_1.get_properties_zhllqc_k$(), listOf(this.second_1));
      }
      mapCondition_3hl8s3_k$(condition) {
        return this.first_1.mapCondition_3hl8s3_k$(OnField().new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(this.second_1, condition));
      }
      mapModification_jpidl5_k$(modification) {
        return this.first_1.mapModification_jpidl5_k$(OnField_0().new_com_lightningkite_services_database_Modification_OnField_3hlyhh_k$(this.second_1, modification));
      }
      get_serializer_u29zhh_k$() {
        return this.second_1.get_serializer_u29zhh_k$();
      }
      hashCode() {
        var result = this.first_1.hashCode();
        result = imul(result, 31) + hashCode(this.second_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathAccess()))
          return false;
        if (!this.first_1.equals(other.first_1))
          return false;
        if (!equals(this.second_1, other.second_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathAccess');
    DataClassPathAccessClass = $;
  }
  return DataClassPathAccessClass;
}
var DataClassPathSelfClass;
function DataClassPathSelf() {
  if (DataClassPathSelfClass === VOID) {
    class $ extends DataClassPath() {
      constructor(serializer) {
        super();
        this.serializer_1 = serializer;
      }
      get_serializer_u29zhh_k$() {
        return this.serializer_1;
      }
      get_wei43m_k$(key) {
        return key;
      }
      set_16wwmq_k$(key, value) {
        return value;
      }
      set_iuhvb1_k$(key, value) {
        return this.set_16wwmq_k$(key, value);
      }
      toString() {
        return 'this';
      }
      hashCode() {
        return 0;
      }
      equals(other) {
        return other instanceof DataClassPathSelf();
      }
      get_properties_zhllqc_k$() {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
      mapCondition_e5zpw8_k$(condition) {
        return condition;
      }
      mapCondition_3hl8s3_k$(condition) {
        return this.mapCondition_e5zpw8_k$(condition);
      }
      mapModification_21xewu_k$(modification) {
        return modification;
      }
      mapModification_jpidl5_k$(modification) {
        return this.mapModification_21xewu_k$(modification);
      }
    }
    initMetadataForClass($, 'DataClassPathSelf');
    DataClassPathSelfClass = $;
  }
  return DataClassPathSelfClass;
}
var DataClassPathClass;
function DataClassPath() {
  if (DataClassPathClass === VOID) {
    class $ extends DataClassPathPartial() {
      getAny_nwh1wi_k$(key) {
        return this.get_wei43m_k$(key);
      }
      prop(prop) {
        return new (DataClassPathAccess())(this, prop);
      }
      get_serializerAny_e3t5u9_k$() {
        return this.get_serializer_u29zhh_k$();
      }
    }
    initMetadataForClass($, 'DataClassPath');
    DataClassPathClass = $;
  }
  return DataClassPathClass;
}
var DataClassPathOfTypeClass;
function DataClassPathOfType() {
  if (DataClassPathOfTypeClass === VOID) {
    class $ extends DataClassPath() {
      constructor(wraps, serializer) {
        super();
        this.wraps_1 = wraps;
        this.serializer_1 = serializer;
        this.discriminator_1 = _SealedTypeDiscriminator___init__impl__jf77jn(this.serializer_1);
      }
      get_serializer_u29zhh_k$() {
        return this.serializer_1;
      }
      get_properties_zhllqc_k$() {
        return this.wraps_1.get_properties_zhllqc_k$();
      }
      get_wei43m_k$(key) {
        var tmp0_safe_receiver = this.wraps_1.get_wei43m_k$(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.handle' call
          var this_0 = this.discriminator_1;
          var tmp_0;
          if (matches(this_0, tmp0_safe_receiver)) {
            tmp_0 = tmp0_safe_receiver;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      set_39ec1b_k$(key, value) {
        var tmp0_safe_receiver = this.wraps_1.get_wei43m_k$(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.handle' call
          var this_0 = this.discriminator_1;
          var tmp_0;
          if (matches(this_0, tmp0_safe_receiver)) {
            tmp_0 = this.wraps_1.set_iuhvb1_k$(key, value);
          } else {
            tmp_0 = key;
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
      }
      set_iuhvb1_k$(key, value) {
        return this.set_39ec1b_k$(key, value);
      }
      mapCondition_3hl8s3_k$(condition) {
        return this.wraps_1.mapCondition_3hl8s3_k$(IfIsType().new_com_lightningkite_services_database_Condition_IfIsType_20q63z_k$(this.discriminator_1, condition));
      }
      mapModification_jpidl5_k$(modification) {
        return this.wraps_1.mapModification_jpidl5_k$(IfIsType_0().new_com_lightningkite_services_database_Modification_IfIsType_v12ard_k$(this.discriminator_1, modification));
      }
      toString() {
        var tmp0_elvis_lhs = variantShortName(this.wraps_1.get_serializer_u29zhh_k$(), this.discriminator_1);
        var name = tmp0_elvis_lhs == null ? _SealedTypeDiscriminator___get_serialName__impl__x46m55(this.discriminator_1) : tmp0_elvis_lhs;
        var tmp;
        var tmp_0 = this.wraps_1;
        if (tmp_0 instanceof DataClassPathSelf()) {
          tmp = '[' + name + ']';
        } else {
          tmp = this.wraps_1.toString() + '.[' + name + ']';
        }
        return tmp;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof DataClassPathOfType()) {
          tmp_0 = other.wraps_1.equals(this.wraps_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = other.discriminator_1 === this.discriminator_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(this.wraps_1.hashCode(), 31) + SealedTypeDiscriminator__hashCode_impl_3l9vn8(this.discriminator_1) | 0;
      }
    }
    initMetadataForClass($, 'DataClassPathOfType');
    DataClassPathOfTypeClass = $;
  }
  return DataClassPathOfTypeClass;
}
var DataClassPathListClass;
function DataClassPathList() {
  if (DataClassPathListClass === VOID) {
    class $ extends DataClassPath() {
      constructor(wraps) {
        super();
        this.wraps_1 = wraps;
      }
      get_properties_zhllqc_k$() {
        return this.wraps_1.get_properties_zhllqc_k$();
      }
      get_wei43m_k$(key) {
        var tmp0_safe_receiver = this.wraps_1.get_wei43m_k$(key);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      set_iuhvb1_k$(key, value) {
        return this.wraps_1.set_iuhvb1_k$(key, listOf(value));
      }
      toString() {
        return this.wraps_1.toString() + '.*';
      }
      mapCondition_3hl8s3_k$(condition) {
        return this.wraps_1.mapCondition_3hl8s3_k$(ListAllElements().new_com_lightningkite_services_database_Condition_ListAllElements_z68vy4_k$(condition));
      }
      mapModification_jpidl5_k$(modification) {
        return this.wraps_1.mapModification_jpidl5_k$(ListPerElement().new_com_lightningkite_services_database_Modification_ListPerElement_sz0zlz_k$(Always_getInstance(), modification));
      }
      get_serializer_u29zhh_k$() {
        var tmp = ensureNotNull(listElement(this.wraps_1.get_serializer_u29zhh_k$()));
        return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
      }
      hashCode() {
        return this.wraps_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathList()))
          return false;
        if (!this.wraps_1.equals(other.wraps_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathList');
    DataClassPathListClass = $;
  }
  return DataClassPathListClass;
}
var DataClassPathNotNullClass;
function DataClassPathNotNull() {
  if (DataClassPathNotNullClass === VOID) {
    class $ extends DataClassPath() {
      constructor(wraps) {
        super();
        this.wraps_1 = wraps;
      }
      get_properties_zhllqc_k$() {
        return this.wraps_1.get_properties_zhllqc_k$();
      }
      get_wei43m_k$(key) {
        return this.wraps_1.get_wei43m_k$(key);
      }
      set_iuhvb1_k$(key, value) {
        return this.wraps_1.set_iuhvb1_k$(key, value);
      }
      toString() {
        return this.wraps_1.toString() + '?';
      }
      mapCondition_3hl8s3_k$(condition) {
        return this.wraps_1.mapCondition_3hl8s3_k$(IfNotNull().new_com_lightningkite_services_database_Condition_IfNotNull_b1oyp_k$(condition));
      }
      mapModification_jpidl5_k$(modification) {
        return this.wraps_1.mapModification_jpidl5_k$(IfNotNull_0().new_com_lightningkite_services_database_Modification_IfNotNull_mgiwu9_k$(modification));
      }
      get_serializer_u29zhh_k$() {
        var tmp = ensureNotNull(nullElement(this.wraps_1.get_serializer_u29zhh_k$()));
        return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
      }
      hashCode() {
        return this.wraps_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathNotNull()))
          return false;
        if (!this.wraps_1.equals(other.wraps_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathNotNull');
    DataClassPathNotNullClass = $;
  }
  return DataClassPathNotNullClass;
}
function get_notNull(_this__u8e3s4) {
  return new (DataClassPathNotNull())(_this__u8e3s4);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DataClassPathAccess as DataClassPathAccess3qupo9g6dhbeb,
  DataClassPathList as DataClassPathList1wm0kncx8ym4m,
  DataClassPathNotNull as DataClassPathNotNull3k4t7brymixty,
  DataClassPathOfType as DataClassPathOfType22v56nemy4d4a,
  DataClassPathPartial as DataClassPathPartial2ywkg16gqhuu6,
  DataClassPathSelf as DataClassPathSelf18kqeagzkbefr,
  DataClassPath as DataClassPath2zx7tvblx35e3,
  get_notNull as get_notNull2od35hy6ssmdh,
  Companion_instance as Companion_instance1blhtv320q15h,
};
//endregion

//# sourceMappingURL=DataClassPath.mjs.map
